module.exports = __webpack_public_path__ + "img/steven-home.fcf86c3c.png";